import { Outlet } from "react-router-dom";
import Navbar from "./Navbar";
import ScrollToTop from "./ScrollToTop";

interface LayoutProps {
  user: any;
  onReviewClick: () => void;
  onOpenReviewerOnboarding: () => void;
}

function Layout({ user, onReviewClick, onOpenReviewerOnboarding }: LayoutProps) {
  return (
    <div className="h-screen flex flex-col overflow-hidden">
      <ScrollToTop />
      <Navbar
        user={user}
        onReviewClick={onReviewClick}
        onOpenReviewerOnboarding={onOpenReviewerOnboarding}
      />
      <div className="flex-1 overflow-y-auto overflow-x-hidden">
        <Outlet />
      </div>
    </div>
  );
}

export default Layout;
